// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__qkvdD","loader":"Loader_loader__bRzeH","spin":"Loader_spin__4_xhr"};